<template>
  <div>
    <v-form>
      <div v-if="settings !== null && !spinner">
        <v-row>
          <v-col cols="6">
            <v-text-field label="Название документа" v-model="settings.name" :rules="[
              () => !!settings.name || 'Вы должны указать название документа',
              () =>
                /^[А-я\s]+$/.test(settings.name) ||
                'Допустимы только символы [А-я]',
            ]"></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field label="Описание" v-model="settings.description"></v-text-field>
          </v-col>
        </v-row>
        <v-row no-gutters align="center">
          <v-col cols="6">
            <v-switch hide-details="true" color="primary" v-model="settings.joinData"
              label="Объединять данные при печати"></v-switch>
          </v-col>
          <v-col cols="6">
            <a href="https://www.procollege.ru/mod/page/view.php?id=203#joinData" target="_blank">
              <v-icon class="mb-4 text-black">mdi-chat-question</v-icon>
            </a>
          </v-col>
        </v-row>
        <v-row no-gutters align="center">
          <v-col cols="6">
            <v-switch hide-details="true" color="primary" v-model="settings.editAll"
              label="Разрешить дорабатывать документ всем в цепочке"></v-switch>
          </v-col>
          <v-col cols="6">
            <a href="https://www.procollege.ru/mod/page/view.php?id=203#editAll" target="_blank">
              <v-icon class="mb-4 text-black">mdi-chat-question</v-icon>
            </a>
          </v-col>
        </v-row>
        <v-row no-gutters align="center">
          <v-col cols="6">
            <v-switch hide-details="true" color="primary" v-model="settings.ignoreDepartment"
              label="Сделать документ общим для всех комплексов"></v-switch>
          </v-col>
          <v-col cols="6">
            <a href="https://www.procollege.ru/mod/page/view.php?id=203#ignoreDepartment" target="_blank">
              <v-icon class="mb-4 text-black">mdi-chat-question</v-icon>
            </a>
          </v-col>
        </v-row>
        <v-row no-gutters align="center">
          <v-col cols="6">
            <v-switch hide-details="true" color="primary" v-model="settings.hide" label="Скрыть"></v-switch>
          </v-col>
          <v-col cols="6">
            <a href="https://www.procollege.ru/mod/page/view.php?id=203#hideCategory" target="_blank">
              <v-icon class="mb-4 text-black">mdi-chat-question</v-icon>
            </a>
          </v-col>
        </v-row>
      </div>
      <template v-else>
        <v-skeleton-loader type="article"></v-skeleton-loader>
      </template>
    </v-form>
  </div>
</template>

<script>
export default {
  emits: [
    "changeCategoryid",
    "update:saved",
  ],
  data() {
    return {
      spinner: false,
      settings: null,
    };
  },
  props: {
    categoryid: false,
    saved: Boolean,
  },
  created() {
    this.$emit("update:saved", false);
    this.axios
      .post(
        this.$model.wwwroot + "/procollege/manage_groups/documents3/categoriesGetSettings",
        new URLSearchParams({
          categoryid: this.categoryid
        })
      )
      .then((response) => {
        this.settings = response.data;
      })
      .catch((error) => {
        this.axiosDefaultErrorHandler(error);
      });

    this.$eventBus.$on("save-category", () => {
      if (!this.settings.name || !/^[А-я\s]+$/.test(this.settings.name)) {
        this.$eventBus.$emit("show-dialog", {
          title: "Ошибка",
          content: "Неверное имя документа",
        });
        return;
      }
      
      if (!this.categoryid) {
        this.settings.catalogid = this.$route.params.id;
        let data = JSON.stringify(this.settings);
        this.spinner = true;
        this.axios
          .post(
            this.$model.wwwroot + "/procollege/manage_groups/documents3/categoriesCreate",
            new URLSearchParams({
              catalogid: this.$route.params.id,
              data: data
            })
          )
          .then((response) => {
            this.spinner = false;
            this.$emit("changeCategoryid", response.data);
          })
          .catch((error) => {
            this.spinner = false;
            this.axiosDefaultErrorHandler(error);
          });

      } else {
        this.updateCategory();
      }

    });
  },
  beforeUnmount() {
    this.$eventBus.$off("save-category");
  },
  methods: {
    updateCategory() {
      this.settings.catalogid = this.$route.params.id;
      let data = JSON.stringify(this.settings);

      this.axios
        .post(
          this.$model.wwwroot + "/procollege/manage_groups/documents3/categoriesUpdate",
          new URLSearchParams({
            id: this.categoryid,
            data: data
          })
        )
        .then((response) => {
          this.$emit("update:saved", true);
        })
        .catch((error) => {
          this.axiosDefaultErrorHandler(error);
        });
    }
  },
};
</script>
<style lang="scss">
div.v-dialog {
  label.v-label {
    margin: 0;
  }
}
</style>